module.exports = __webpack_public_path__ + "img/logo_fuseaccess.8b900f5a.png";